import FormType from "enums/FormType";

/**
 * Route utility functions for quality forms application
 */

/**
 * Get the forms list route path
 * @param formType The type of form (evaluation or survey)
 * @returns The route path to the forms list
 */
export const getFormsListRoutePath = (
    formType: FormType | undefined
): string => {
    if (formType === undefined) {
        console.error("FormType must be defined for route generation");
    }
    return `#/${formType}Forms`;
};

/**
 * Get the admin forms list route path
 * @param formType The type of form (evaluation or survey)
 * @returns The admin route path to the forms list
 */
export const getOldFormsListRoutePath = (
    formType: FormType | undefined
): string => {
    if (formType === undefined) {
        console.error("FormType must be defined for route generation");
    }
    return `#admin/${formType}Forms`;
};

/**
 * Get the form detail route path
 * @param formType The type of form (evaluation or survey)
 * @param id The ID of the form
 * @returns The route path to the form detail
 */
export const getFormDetailRoutePath = (
    formType: FormType | undefined,
    id: string
): string => {
    if (formType === undefined) {
        console.error("FormType must be defined for route generation");
    }
    return `#/${formType}Forms/${id}`;
};

/**
 * Get the admin form detail route path
 * @param formType The type of form (evaluation or survey)
 * @param id The ID of the form
 * @returns The admin route path to the form detail
 */
export const getOldFormDetailRoutePath = (
    formType: FormType | undefined,
    id: string
): string => {
    if (formType === undefined) {
        console.error("FormType must be defined for route generation");
    }
    return `#admin/${formType}Forms/${id}`;
};

/**
 * Get the automated evaluation form detail route path
 * @param formType The type of form (should be evaluation)
 * @param id The ID of the form
 * @returns The route path to the automated evaluation form detail
 */
export const getAutomatedEvaluationFormDetailRoutePath = (
    formType: FormType | undefined,
    id: string
): string => {
    if (formType === undefined) {
        console.error("FormType must be defined for route generation");
    }
    return `#/${formType}Forms/automated/${id}`;
};

/**
 * Agent scoring rules table route (collection).
 */
export const getAgentScoringRulesPath = (programId: string): string =>
    `/programs/${programId}/agentScoringRules`;

/**
 * Create-rule editor route. Aligns with PDUI `/agentScoringRule` (no id).
 */
export const getAgentScoringRuleCreatePath = (programId: string): string =>
    `/programs/${programId}/agentScoringRule`;

/**
 * Edit-rule editor route. Aligns with PDUI `/agentScoringRule/:ruleId`.
 */
export const getAgentScoringRuleEditorPath = (
    programId: string,
    ruleId: string
): string => `/programs/${programId}/agentScoringRule/${ruleId}`;
